export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage':
    '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名: admin or user',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼: ant.design',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.searchTable.selectToDelete': '請選擇要刪除的項',

  'pages.403.subTitle': '抱歉，您沒有權限存取此頁面。',
  'pages.403.buttonText': '返回首頁',

  // 任務相關字段
  'pages.task.owner': '產權人',
  'pages.task.propertyCert': '產權證號',
  'pages.task.region': '省市區',
  'pages.task.cardAddress': '證載地址',
  'pages.task.houseUsage': '證載房屋用途',
  'pages.task.landUsage': '證載土地用途',
  'pages.task.houseRightNature': '證載房屋權利性質',
  'pages.task.landRightNature': '證載土地權利性質',
  'pages.task.houseRightType': '證載房屋權利類型',
  'pages.task.landRightType': '證載土地權利類型',
  'pages.task.landExpiry': '土地使用權終止日期',
  'pages.task.building': '樓盤',
  'pages.task.buildingNo': '樓棟號',
  'pages.task.unitNo': '單元號',
  'pages.task.householdNo': '戶號',
  'pages.task.bedroom': '居室',
  'pages.task.hall': '廳',
  'pages.task.kitchen': '廚房',
  'pages.task.toilet': '衛生間',
  'pages.task.buildingArea': '房屋建築面積(㎡)',
  'pages.task.sharedLandArea': '分攤土地面積(㎡)',
  'pages.task.sharedBuildingArea': '分攤建築面積(㎡)',
  'pages.task.landArea': '土地使用權面積(㎡)',
  'pages.task.innerArea': '套內面積(㎡)',
  'pages.task.actualUsedType': '實際用途',
  'pages.task.usageStatus': '使用狀況',
  'pages.task.floorPosition': '所在樓層',
  'pages.task.totalFloors': '總樓層',
  'pages.task.finishTime': '建成年份',
  'pages.task.purchaseDuration': '購買年限',
  'pages.task.taxPolicy': '淨值方案',
  'pages.task.shopsType': '商舖類型',
  'pages.task.shopsAmount': '商舖租金(元/月)',
  'pages.task.coOwnership': '共有人',
  'pages.task.coOwnershipCircumstance': '共有情況',
  'pages.task.ownershipInfo': '權屬信息',
  'pages.task.smartRecognition': '智能識別',
  'pages.task.smartCalculation': '智能測算',
  'pages.task.comparativeData': '比價資料',
  'pages.task.calculationTable': '測算表',
  'pages.task.downloadReportPDF': '下載報告PDF',
  'pages.task.viewReport': '查看報告',
  'pages.netValueSolution.customParams.button': '自訂參數',
  'pages.netValueSolution.customParams.title': '自訂參數',
  'pages.netValueSolution.customParams.back': '返回',
  'pages.netValueSolution.customParams.col.name': '展示名稱',
  'pages.netValueSolution.customParams.col.paramKey': '業務鍵',
  'pages.netValueSolution.customParams.col.paramValue': '參數值',
  'pages.netValueSolution.customParams.col.order': '排序',
  'pages.netValueSolution.customParams.col.action': '操作',
  'pages.netValueSolution.customParams.col.deductionItem': '扣減項',
  'pages.netValueSolution.customParams.col.calcCondition': '計算條件',
  'pages.netValueSolution.customParams.col.calcFormula': '計算公式',
  'pages.netValueSolution.customParams.action.edit': '編輯',
  'pages.netValueSolution.customParams.action.delete': '刪除',
  'pages.netValueSolution.planDetailLoading': '正在載入淨值方案詳情…',
  'pages.netValueSolution.customParams.missingPlanId': '缺少淨值方案資訊，已返回列表',
  'pages.netValueSolution.customParams.needSavedPlan': '請先儲存淨值方案後再設定自訂參數',
  'pages.netValueSolution.customParams.addButton': '新增自訂參數',
  'pages.netValueSolution.customParams.modalAddTitle': '新增自訂參數',
  'pages.netValueSolution.customParams.modalEditTitle': '編輯自訂參數',
  'pages.netValueSolution.customParams.confirmDelete': '確定刪除此自訂參數嗎？',
  'pages.netValueSolution.customParams.loadListFailed': '載入自訂參數失敗',
  'pages.netValueSolution.customParams.saveSuccess': '儲存成功',
  'pages.netValueSolution.customParams.saveFailed': '儲存失敗',
  'pages.netValueSolution.customParams.saving': '儲存中…',
  'pages.netValueSolution.customParams.loadingDetail': '載入詳情中…',
  'pages.netValueSolution.customParams.loadDetailFailed': '載入自訂參數詳情失敗',
  'pages.netValueSolution.customParams.deleteSuccess': '刪除成功',
  'pages.netValueSolution.customParams.deleteFailed': '刪除失敗',
  'pages.netValueSolution.customParams.rules.name': '請輸入展示名稱',
  'pages.netValueSolution.customParams.rules.paramKey': '請輸入業務鍵',
  'pages.netValueSolution.customParams.rules.orderIndex': '請輸入排序',
  'pages.netValueSolution.deduction.modalAdd': '新增扣減項',
  'pages.netValueSolution.deduction.modalEdit': '編輯扣減項',
  'pages.netValueSolution.deduction.modalAddTaxRate': '添加稅率',
  'pages.netValueSolution.table.confirmDelete': '確定刪除此筆資料嗎？',
  'pages.netValueSolution.table.confirmDeleteWithChildren':
    '確定刪除此筆資料嗎？刪除後將一併刪除所有相關子資料。',
  'pages.netValueSolution.formulaConfig.title': '配置計算公式',
  'pages.netValueSolution.add.pageTitle': '新增淨值方案',
  'pages.netValueSolution.edit.pageTitle': '編輯淨值方案',
  'pages.netValueSolution.taxCard.title': '稅費扣減項',
  'pages.netValueSolution.conditionRequired': '計算條件至少需要選擇一個',
  'pages.netValueSolution.taxModal.deductionNameRequired': '請輸入扣減項名稱',
  'pages.netValueSolution.taxModal.childConditionRequired': '子項請至少選擇或填寫一項計算條件後再儲存',
  'pages.netValueSolution.taxModal.formulaRequired': '請先設定計算公式後再儲存',
  'pages.netValueSolution.message.savePlanSuccess': '淨值方案已儲存',
  'pages.netValueSolution.message.addDeductionSuccess': '已新增扣減項',
  'pages.netValueSolution.message.loadDetailFailed': '載入淨值方案詳情失敗',
  'pages.netValueSolution.message.defaultItemCannotDelete': '預設的增減項不允許刪除',
  'pages.netValueSolution.message.taxRateMax100': '稅率最大不允許超過100',
  'pages.netValueSolution.message.dataAbnormalRetry': '資料異常，請關閉後重試',
  'pages.netValueSolution.message.updateTaxRateSuccess': '更新稅率成功',
  'pages.netValueSolution.message.addTaxRateSuccess': '添加稅率成功',
  'pages.netValueSolution.message.checkRequiredFieldsEmpty': '請檢查必填項不能為空',
  'pages.netValueSolution.message.checkRequiredFieldsWithDetails': '請檢查以下必填項：{details}',
  'pages.netValueSolution.message.selectAtLeastOneDeduction': '請至少勾選一條扣減項，否則無法提交',
  'pages.netValueSolution.message.unknownField': '未知欄位',
  'pages.netValueSolution.addForm.label.cityName': '適用城市',
  'pages.netValueSolution.addForm.label.districtCode': '適用區縣',
  'pages.netValueSolution.addForm.label.provinceCode': '適用省份',
  'pages.netValueSolution.addForm.label.bankId': '適用銀行',
  'pages.netValueSolution.addForm.label.businessLines': '業務領域',
  'pages.netValueSolution.addForm.label.businessType': '業務類型',
  'pages.netValueSolution.addForm.label.netWorthName': '抵押淨值',
  'pages.netValueSolution.addForm.label.organizationId': '適用機構',
  'pages.netValueSolution.addForm.rules.selectCity': '請選擇適用城市',
  'pages.netValueSolution.addForm.rules.selectProvince': '請選擇省份',
  'pages.netValueSolution.addForm.rules.selectBank': '請選擇適用銀行',
  'pages.netValueSolution.addForm.rules.selectBusinessLines': '請選擇業務領域',
  'pages.netValueSolution.addForm.rules.selectBusinessType': '請選擇業務類型',
  'pages.netValueSolution.addForm.rules.selectNetWorth': '請選擇抵押淨值',
  'pages.netValueSolution.addForm.rules.selectOrganization': '請選擇適用機構',
  'pages.netValueSolution.addForm.placeholder.selectProvince': '請選擇省份',
  'pages.netValueSolution.addForm.placeholder.selectCity': '請選擇城市',
  'pages.netValueSolution.addForm.placeholder.selectDistrict': '請選擇區縣',
  'pages.netValueSolution.addForm.placeholder.selectBank': '請選擇適用銀行',
  'pages.netValueSolution.addForm.placeholder.selectBusinessLines': '請選擇業務領域',
  'pages.netValueSolution.addForm.placeholder.selectBusinessType': '請選擇業務類型',
  'pages.netValueSolution.addForm.placeholder.selectNetWorth': '請選擇抵押淨值',
  'pages.netValueSolution.addForm.placeholder.selectOrganization': '請選擇適用機構',
  'pages.netValueSolution.addForm.alertLine1':
    '預設方式為系統設定的計算方式，當存在不符合使用者所設定的計算方式，則系統會使用預設方式計算相關的稅費值。',
  'pages.netValueSolution.addForm.alertLine2': '稅費扣減項的新增，可新增自訂的扣減項目，計算方式為預設方式。',
  'pages.netValueSolution.addForm.alertLine3': '稅費項列表的新增，則新增相對應稅種的多種情況下的稅率。',
  'pages.netValueSolution.addNewDeduction': '新增扣減項',

  'pages.netValueSolution.list.title': '淨值方案',
  'pages.netValueSolution.list.addButton': '新增淨值方案',
  'pages.netValueSolution.list.loadListFailed': '取得淨值方案列表失敗',
  'pages.netValueSolution.list.loadListFailedRetry': '取得淨值方案列表失敗，請重試',
  'pages.netValueSolution.list.missingPlanId': '無法取得淨值方案 ID',
  'pages.netValueSolution.list.confirmDeleteTitle': '確認刪除',
  'pages.netValueSolution.list.confirmDeleteContent': '刪除後資料將無法復原，確定要刪除此淨值方案嗎？',
  'pages.netValueSolution.list.deleteItemLabel': '淨值方案「{name}」',
  'pages.netValueSolution.list.edit': '編輯',
  'pages.netValueSolution.list.copy': '複製',
  'pages.netValueSolution.list.col.province': '適用省份',
  'pages.netValueSolution.list.col.city': '適用城市',
  'pages.netValueSolution.list.col.district': '適用區縣',
  'pages.netValueSolution.list.col.bank': '適用銀行',
  'pages.netValueSolution.list.col.businessLines': '業務領域',
  'pages.netValueSolution.list.col.businessType': '業務類型',
  'pages.netValueSolution.list.col.organization': '所屬機構',
  'pages.netValueSolution.list.col.netWorthName': '淨值名稱',
  'pages.netValueSolution.list.col.deductItems': '稅費扣減項',
  'pages.netValueSolution.list.col.action': '操作',
  'pages.netValueSolution.list.ph.province': '請選擇省份',
  'pages.netValueSolution.list.ph.city': '請選擇城市',
  'pages.netValueSolution.list.ph.district': '請選擇區縣',
  'pages.netValueSolution.list.ph.bank': '請選擇適用銀行',
  'pages.netValueSolution.list.ph.businessLines': '請選擇業務領域',
  'pages.netValueSolution.list.ph.businessType': '請選擇業務類型',
  'pages.netValueSolution.list.ph.organization': '請選擇所屬機構',
  'pages.netValueSolution.list.ph.netWorthName': '請選擇淨值名稱',
  'pages.netValueSolution.list.paginationTotal': '第 {start}-{end} 條/共 {total} 條',

  'pages.universalParams.title': '通用參數列表',
  'pages.universalParams.addButton': '新增通用參數',
  'pages.universalParams.col.orderIndex': '排序',
  'pages.universalParams.col.name': '參數名稱',
  'pages.universalParams.col.description': '描述',
  'pages.universalParams.col.value': '值',
  'pages.universalParams.col.action': '操作',
  'pages.universalParams.loadListFailed': '載入列表失敗',
  'pages.universalParams.loadDetailFailed': '取得詳情失敗',
  'pages.universalParams.confirmDeleteTitle': '確認刪除',
  'pages.universalParams.confirmDeleteDesc': '確定刪除參數「{name}」嗎？',
  'pages.universalParams.modal.addTitle': '新增通用參數',
  'pages.universalParams.modal.editTitle': '編輯通用參數',
  'pages.universalParams.form.name': '參數名稱',
  'pages.universalParams.form.namePlaceholder': '展示名稱',
  'pages.universalParams.form.description': '描述',
  'pages.universalParams.form.descriptionPlaceholder': '可選',
  'pages.universalParams.form.value': '參數值（value）',
  'pages.universalParams.form.valuePlaceholder': 'tb_task_record.appraisal_value',
  'pages.universalParams.form.orderIndex': '排序',
  'pages.universalParams.form.orderPlaceholder': '數字越小越靠前',
  'pages.universalParams.rules.nameRequired': '請輸入參數名稱',
  'pages.universalParams.rules.valueRequired': '請輸入參數值',
  'pages.universalParams.rules.valueFormat':
    '須為 tb_表名.欄位名 格式（全小寫與底線），例如 tb_task_record.appraisal_value',
  'pages.universalParams.extra.valueHint':
    '公式中 PARAM 的 key 與此一致，必須為 tb_前綴表名.欄位名，例如 tb_task_record.value',

  'pages.system.logs.headerTitle': '操作日誌',
  'pages.system.logs.col.modelName': '操作模組',
  'pages.system.logs.col.apiName': '操作內容',
  'pages.system.logs.col.userName': '操作人',
  'pages.system.logs.col.requestIp': '請求 IP',
  'pages.system.logs.col.status': '狀態',
  'pages.system.logs.col.createTime': '操作時間',
  'pages.system.logs.col.timeRange': '操作時間',
  'pages.system.logs.ph.module': '請選擇操作模組',
  'pages.system.logs.ph.userName': '請輸入操作人',
  'pages.system.logs.fetchModulesFailed': '取得操作模組列表失敗',

  'pages.system.permission.addButton': '新增權限',
  'pages.system.permission.col.name': '權限名稱',
  'pages.system.permission.col.desc': '描述',
  'pages.system.permission.col.action': '操作',
  'pages.system.permission.configureApi': '配置 API',
  'pages.system.permission.deleteItemName': '權限「{name}」',
  'pages.system.permission.batchSelected': '選中的 {count} 個權限',
  'pages.system.permission.apiConfigSuccess': 'API 權限配置成功',
  'pages.system.permission.apiConfigFailed': 'API 權限配置失敗',
  'pages.system.permission.apiConfigFailedRetry': 'API 權限配置失敗，請重試',
  'pages.system.permission.apiModalTitle': '配置 API 權限 - {name}',
  'pages.system.permission.selectToDelete': '請選擇要刪除的權限',

  'pages.system.role.col.name': '角色名稱',
  'pages.system.role.col.description': '角色描述',
  'pages.system.role.col.action': '操作',
  'pages.system.role.deleteItemName': '角色【{name}】',
  'pages.system.role.batchSelected': '選中的 {count} 個角色',
  'pages.system.role.configurePermission': '配置權限',
  'pages.system.role.configureMenuPermission': '配置選單權限',
  'pages.system.role.apiConfigSuccess': 'API 權限配置成功',
  'pages.system.role.permissionConfigSuccess': '權限配置成功',
  'pages.system.role.menuPermissionConfigSuccess': '選單權限配置成功',
  'pages.system.role.deleteFailedCount': '{count} 個角色刪除失敗',

  'pages.system.menu.col.name': '權限名稱',
  'pages.system.menu.col.code': '權限 Code',
  'pages.system.menu.col.action': '操作',
  'pages.system.menu.addButton': '新增選單',
  'pages.system.menu.addSubMenu': '新增子選單',
  'pages.system.menu.deleteItemName': '選單「{name}」',

  'pages.system.dept.pageTitle': '部門管理',
  'pages.system.dept.refresh': '重新整理',
  'pages.system.dept.addDept': '新增部門',
  'pages.system.dept.addChildDept': '新增子部門',
  'pages.system.dept.editDept': '編輯部門',
  'pages.system.dept.treeTitle': '部門樹',
  'pages.system.dept.orgCount': '共 {count} 個機構',
  'pages.system.dept.emptyTree': '暫無部門資料',
  'pages.system.dept.detailDept': '部門詳情',
  'pages.system.dept.detailOrg': '機構詳情',
  'pages.system.dept.edit': '編輯',
  'pages.system.dept.delete': '刪除',
  'pages.system.dept.label.deptName': '部門名稱',
  'pages.system.dept.label.deptId': '部門ID',
  'pages.system.dept.label.parentDept': '上級部門',
  'pages.system.dept.label.status': '狀態',
  'pages.system.dept.label.childCount': '子部門數量',
  'pages.system.dept.label.ownerOrg': '所屬機構/客戶',
  'pages.system.dept.label.orgName': '機構/客戶名稱',
  'pages.system.dept.label.orgId': '機構/客戶ID',
  'pages.system.dept.label.ownerType': '類型',
  'pages.system.dept.type.organization': '機構',
  'pages.system.dept.type.customer': '客戶',
  'pages.system.dept.status.enabled': '啟用',
  'pages.system.dept.status.disabled': '禁用',
  'pages.system.dept.parentRoot': '無（根部門）',
  'pages.system.dept.selectNodeHint': '請選擇左側的部門節點或機構節點',
  'pages.system.dept.unnamedDept': '未命名部門',
  'pages.system.dept.ungrouped': '未分組',
  'pages.system.dept.unnamed': '未命名',
  'pages.system.dept.fetchTreeFail': '取得部門樹失敗',
  'pages.system.dept.fetchTreeFailRetry': '取得部門樹失敗，請稍後重試',
  'pages.system.dept.cannotDeleteInvalid': '無法刪除無效的部門節點',
  'pages.system.dept.cannotDeleteRoot': '根部門不允許刪除',
  'pages.system.dept.defaultItemName': '部門',
  'pages.system.dept.deleteTitle': '確認刪除該部門嗎？',
  'pages.system.dept.deleteContent': '刪除後無法復原，該部門的子部門也會受到影響。',
  'pages.system.dept.deleteSuccess': '刪除成功',
  'pages.system.dept.deleteFail': '刪除失敗',
  'pages.system.dept.deleteFailRetry': '刪除失敗，請稍後再試',
  'pages.system.dept.editMissingOwner': '編輯部門時缺少所屬機構/客戶資訊，請重新整理後重試',
  'pages.system.dept.saveSuccessEdit': '編輯部門成功',
  'pages.system.dept.saveSuccessAdd': '新增部門成功',
  'pages.system.dept.saveFail': '儲存失敗',
  'pages.system.dept.form.name': '部門名稱',
  'pages.system.dept.form.nameRequired': '請輸入部門名稱',
  'pages.system.dept.form.nameMax': '部門名稱不能超過50個字元',
  'pages.system.dept.form.namePlaceholder': '請輸入部門名稱',
  'pages.system.dept.form.ownerOrg': '所屬機構',
  'pages.system.dept.form.ownerOrgRequired': '請選擇所屬機構',
  'pages.system.dept.form.ownerOrgPlaceholder': '請選擇所屬機構',
  'pages.system.dept.form.ownerOrgCustomer': '所屬機構/客戶',
  'pages.system.dept.form.ownerSelectedPlaceholder': '已選擇機構/客戶',
  'pages.system.dept.form.parentDept': '上級部門',
  'pages.system.dept.form.parentDeptPlaceholder': '請選擇上級部門',

  'pages.operations.statTotalCustomers': '總客戶數',
  'pages.operations.statNewThisMonth': '本月新增',
  'pages.operations.statPendingTasks': '待處理任務',
  'pages.operations.statReportsDone': '已完成報告',
  'pages.operations.taskRateTitle': '任務完成率',
  'pages.operations.recentActivityTitle': '最近活動',
  'pages.operations.col.time': '時間',
  'pages.operations.col.activity': '活動',
  'pages.operations.col.operator': '操作人',
  'pages.operations.col.status': '狀態',
  'pages.operations.taskName.evaluation': '客戶評估',
  'pages.operations.taskName.report': '報告產生',
  'pages.operations.taskName.finance': '財務審核',
  'pages.operations.taskName.maintenance': '系統維護',
  'pages.operations.status.done': '已完成',
  'pages.operations.status.inProgress': '進行中',
  'pages.operations.systemStatusTitle': '系統狀態概覽',
  'pages.operations.cpuUsage': 'CPU 使用率',
  'pages.operations.memoryUsage': '記憶體使用率',
  'pages.operations.diskUsage': '磁碟使用率',
  'pages.operations.demo.action1': '新增客戶評估任務',
  'pages.operations.demo.action2': '完成財務報告審核',
  'pages.operations.demo.action3': '系統維護更新',
  'pages.operations.demo.action4': '客戶滿意度調查',
  'pages.operations.demo.user1': '張三',
  'pages.operations.demo.user2': '李四',
  'pages.operations.demo.user3': '王五',
  'pages.operations.demo.user4': '趙六',

  'pages.finance.tooltip.view': '查看詳情',
  'pages.finance.tooltip.edit': '編輯',
  'pages.finance.tooltip.delete': '刪除',
  'pages.finance.stat.totalIncome': '總收入',
  'pages.finance.stat.totalExpense': '總支出',
  'pages.finance.stat.netIncome': '淨收入',
  'pages.finance.modal.add': '新增財務記錄',
  'pages.finance.modal.edit': '編輯財務記錄',
  'pages.finance.addRecord': '新增記錄',
  'pages.finance.paginationTotal': '第 {start}-{end} 條/共 {total} 筆記錄',

  'pages.platform.tooltip.view': '查看詳情',
  'pages.platform.tooltip.edit': '編輯',
  'pages.platform.tooltip.delete': '刪除',
  'pages.platform.modal.add': '新增維護記錄',
  'pages.platform.modal.edit': '編輯維護記錄',
  'pages.platform.addRecord': '新增維護',
  'pages.platform.paginationTotal': '共 {total} 筆記錄',
  'pages.platform.column.id': '維護ID',
  'pages.platform.column.title': '標題',
  'pages.platform.column.type': '類型',
  'pages.platform.column.priority': '優先級',
  'pages.platform.column.status': '狀態',
  'pages.platform.column.progress': '進度',
  'pages.platform.column.assignee': '負責人',
  'pages.platform.column.createTime': '建立時間',
  'pages.platform.column.estimatedTime': '預計完成',
  'pages.platform.column.action': '操作',
  'pages.platform.overview.ok': '系統正常',
  'pages.platform.overview.running': '運行中',
  'pages.platform.overview.attention': '需要關注',
  'pages.platform.overview.error': '異常',
  'pages.platform.alert.title': '系統狀態監控',
  'pages.platform.alert.cpu': 'CPU使用率',
  'pages.platform.alert.memory': '記憶體使用率',
  'pages.platform.alert.disk': '磁碟使用率',
  'pages.platform.alert.network': '網路狀態',
  'pages.platform.alert.networkOk': '正常',
  'pages.platform.filter.searchPlaceholder': '搜尋維護標題或描述',
  'pages.platform.filter.typePlaceholder': '選擇類型',
  'pages.platform.filter.statusPlaceholder': '選擇狀態',
  'pages.platform.filter.priorityPlaceholder': '選擇優先級',
  'pages.platform.filter.assigneePlaceholder': '負責人篩選',
  'pages.platform.type.all': '全部類型',
  'pages.platform.type.performance': '性能優化',
  'pages.platform.type.security': '安全維護',
  'pages.platform.type.hardware': '硬體維護',
  'pages.platform.status.all': '全部狀態',
  'pages.platform.status.pending': '待開始',
  'pages.platform.status.ongoing': '進行中',
  'pages.platform.status.completed': '已完成',
  'pages.platform.priority.all': '全部優先級',
  'pages.platform.priority.high': '高',
  'pages.platform.priority.medium': '中',
  'pages.platform.priority.low': '低',
  'pages.platform.stat.total': '總維護數',
  'pages.platform.stat.completed': '已完成',
  'pages.platform.stat.inProgress': '進行中',
  'pages.platform.stat.pending': '待開始',
  'pages.platform.confirmDelete': '確認刪除',
  'pages.platform.confirmDeleteContent': '確定要刪除維護記錄 {title} 嗎？',
  'pages.platform.msg.deleteSuccess': '刪除成功',
  'pages.platform.msg.updateSuccess': '更新成功',
  'pages.platform.msg.addSuccess': '新增成功',
  'pages.platform.form.title': '維護標題',
  'pages.platform.form.titleRequired': '請輸入維護標題',
  'pages.platform.form.titlePlaceholder': '請輸入維護標題',
  'pages.platform.form.type': '維護類型',
  'pages.platform.form.typeRequired': '請選擇維護類型',
  'pages.platform.form.typePerformance': '性能優化',
  'pages.platform.form.typeSecurity': '安全維護',
  'pages.platform.form.typeHardware': '硬體維護',
  'pages.platform.form.typeSoftware': '軟體更新',
  'pages.platform.form.priority': '優先級',
  'pages.platform.form.priorityRequired': '請選擇優先級',
  'pages.platform.form.assignee': '負責人',
  'pages.platform.form.assigneeRequired': '請輸入負責人',
  'pages.platform.form.assigneePlaceholder': '請輸入負責人',
  'pages.platform.form.estimatedTime': '預計完成時間',
  'pages.platform.form.estimatedTimeRequired': '請選擇預計完成時間',
  'pages.platform.form.estimatedTimePlaceholder': '如: 2024-01-20',
  'pages.platform.form.description': '維護描述',
  'pages.platform.form.descriptionRequired': '請輸入維護描述',
  'pages.platform.form.descriptionPlaceholder': '請輸入維護描述',
  'pages.platform.form.status': '狀態',

  'pages.activity.tooltip.view': '查看詳情',
  'pages.activity.tooltip.edit': '編輯',
  'pages.activity.tooltip.delete': '刪除',
  'pages.activity.modal.add': '新增活動',
  'pages.activity.modal.edit': '編輯活動',
  'pages.activity.addRecord': '新增活動',
  'pages.activity.paginationTotal': '共 {total} 筆記錄',
  'pages.activity.column.id': '活動ID',
  'pages.activity.column.title': '活動標題',
  'pages.activity.column.type': '類型',
  'pages.activity.column.startTime': '開始時間',
  'pages.activity.column.endTime': '結束時間',
  'pages.activity.column.location': '地點',
  'pages.activity.column.status': '狀態',
  'pages.activity.column.participants': '參與人數',
  'pages.activity.column.budget': '預算',
  'pages.activity.column.organizer': '組織者',
  'pages.activity.column.action': '操作',
  'pages.activity.stat.total': '總活動數',
  'pages.activity.stat.inProgress': '進行中',
  'pages.activity.stat.registering': '報名中',
  'pages.activity.stat.ended': '已結束',
  'pages.activity.filter.searchPlaceholder': '搜尋活動標題或組織者',
  'pages.activity.filter.typePlaceholder': '選擇類型',
  'pages.activity.filter.statusPlaceholder': '選擇狀態',
  'pages.activity.filter.locationPlaceholder': '地點篩選',
  'pages.activity.type.all': '全部類型',
  'pages.activity.type.customer': '客戶活動',
  'pages.activity.type.training': '技術培訓',
  'pages.activity.type.meeting': '內部會議',
  'pages.activity.status.all': '全部狀態',
  'pages.activity.status.planning': '策劃中',
  'pages.activity.status.registration': '報名中',
  'pages.activity.status.ongoing': '進行中',
  'pages.activity.status.ended': '已結束',
  'pages.activity.rangeStart': '開始日期',
  'pages.activity.rangeEnd': '結束日期',
  'pages.activity.confirmDelete': '確認刪除',
  'pages.activity.confirmDeleteContent': '確定要刪除活動 {title} 嗎？',
  'pages.activity.msg.deleteSuccess': '刪除成功',
  'pages.activity.msg.updateSuccess': '更新成功',
  'pages.activity.msg.addSuccess': '新增成功',
  'pages.activity.form.title': '活動標題',
  'pages.activity.form.titleRequired': '請輸入活動標題',
  'pages.activity.form.titlePlaceholder': '請輸入活動標題',
  'pages.activity.form.type': '活動類型',
  'pages.activity.form.typeRequired': '請選擇活動類型',
  'pages.activity.form.organizer': '組織者',
  'pages.activity.form.organizerRequired': '請輸入組織者',
  'pages.activity.form.organizerPlaceholder': '請輸入組織者',
  'pages.activity.form.startTime': '開始時間',
  'pages.activity.form.startTimeRequired': '請選擇開始時間',
  'pages.activity.form.endTime': '結束時間',
  'pages.activity.form.endTimeRequired': '請選擇結束時間',
  'pages.activity.form.location': '活動地點',
  'pages.activity.form.locationRequired': '請輸入活動地點',
  'pages.activity.form.locationPlaceholder': '請輸入活動地點',
  'pages.activity.form.maxParticipants': '最大參與人數',
  'pages.activity.form.maxParticipantsRequired': '請輸入最大參與人數',
  'pages.activity.form.budget': '預算金額',
  'pages.activity.form.budgetRequired': '請輸入預算金額',
  'pages.activity.form.activityStatus': '活動狀態',

  // --- 核心業務：客戶 / 任務 / 報告 / 台帳 / 使用者（列表與通用操作）---
  'pages.customer.list.col.customerName': '客戶名稱',
  'pages.customer.list.col.customerType': '客戶類型',
  'pages.customer.list.col.province': '所處省份',
  'pages.customer.list.col.city': '所處城市',
  'pages.customer.list.col.district': '所處行政區',
  'pages.customer.list.col.organization': '所屬機構',
  'pages.customer.list.col.status': '狀態',
  'pages.customer.list.col.contact': '客戶聯絡人',
  'pages.customer.list.col.contactPhone': '客戶聯絡方式',
  'pages.customer.list.col.createTime': '建立時間',
  'pages.customer.list.col.updateTime': '更新時間',
  'pages.customer.list.col.action': '操作',
  'pages.customer.list.confirmToggleTitle': '確認{action}',
  'pages.customer.list.confirmToggleContent': '確定要{action}該客戶嗎？',
  'pages.customer.list.itemNamed': '客戶「{name}」',
  'pages.customer.list.batchItemName': '選中的 {count} 個客戶',
  'pages.customer.list.batchContent': '刪除後資料將無法復原，確定要刪除選中的客戶嗎？',
  'pages.customer.list.batchResultAllSuccess': '成功刪除 {success} 個客戶',
  'pages.customer.list.batchResultPartial': '成功刪除 {success} 個客戶，{fail} 個刪除失敗',
  'pages.customer.list.batchFailed': '批次刪除失敗',
  'pages.customer.list.exportOrgTemplate': '機構客戶範本',
  'pages.customer.list.exportPersonalTemplate': '個人客戶範本',
  'pages.customer.list.exportUserTemplate': '客戶使用者範本',
  'pages.customer.list.exportTemplate': '匯出範本',
  'pages.customer.list.importCustomer': '匯入客戶',
  'pages.customer.list.importCustomerUser': '匯入客戶使用者',
  'pages.customer.list.addCustomer': '新增客戶',
  'pages.customer.list.fileNameOrgTemplate': '機構客戶匯入範本.xlsx',
  'pages.customer.list.fileNamePersonalTemplate': '個人客戶匯入範本.xlsx',
  'pages.customer.list.fileNameUserTemplate': '客戶使用者匯入範本.xlsx',
  'pages.customer.list.deleteContent': '刪除後資料將無法復原，確定要刪除該客戶嗎？',
  'pages.customer.list.toggleSuccess': '{action}成功',
  'pages.customer.list.toggleFail': '{action}失敗',

  'pages.taskMgmt.col.taskNumber': '任務編號',
  'pages.taskMgmt.col.reportNumber': '報告編號',
  'pages.taskMgmt.col.taskName': '任務名稱',
  'pages.taskMgmt.col.specialSituation': '特殊情況',
  'pages.taskMgmt.col.taskStatus': '任務狀態',
  'pages.taskMgmt.col.creator': '建立人',
  'pages.taskMgmt.col.currentOperator': '目前操作人',
  'pages.taskMgmt.col.province': '所屬省份',
  'pages.taskMgmt.col.city': '所屬城市',
  'pages.taskMgmt.col.district': '所屬行政區',
  'pages.taskMgmt.col.createTime': '建立時間',
  'pages.taskMgmt.col.action': '操作',
  'pages.taskMgmt.action.view': '檢視',
  'pages.taskMgmt.action.edit': '編輯',
  'pages.taskMgmt.unknownStatus': '未知狀態',
  'pages.taskMgmt.createLoading': '正在建立任務…',
  'pages.taskMgmt.createFail': '建立任務失敗，請重試',
  'pages.taskMgmt.deleteTitle': '確認刪除',
  'pages.taskMgmt.deleteContent': '確定要刪除任務「{name}」嗎？',
  'pages.taskMgmt.noTaskId': '任務 ID 不存在，無法刪除',
  'pages.taskMgmt.redoTitle': '確認重做',
  'pages.taskMgmt.redoContent': '確定要重做任務「{name}」嗎？',
  'pages.taskMgmt.redoSuccess': '任務重做成功',
  'pages.taskMgmt.fetchListFail': '取得任務列表失敗',
  'pages.taskMgmt.fetchListFailRetry': '取得任務列表失敗，請重試',
  'pages.taskMgmt.modalAddTitle': '新增任務',
  'pages.taskMgmt.formTaskName': '任務名稱',
  'pages.taskMgmt.formTaskNameMax': '任務名稱不能超過 100 個字元',
  'pages.taskMgmt.formTaskNamePlaceholder': '請輸入任務名稱（選填）',
  'pages.taskMgmt.paginationTotal': '第 {start}-{end} 筆／共 {total} 筆',

  'pages.report.col.electronicCode': '電子報告提取碼',
  'pages.report.col.estimateCode': '報告編號',
  'pages.report.col.taskName': '任務名稱',
  'pages.report.col.state': '任務狀態',
  'pages.report.col.creator': '建立人',
  'pages.report.col.operator': '目前操作人',
  'pages.report.col.organization': '所屬機構',
  'pages.report.col.province': '所屬省份',
  'pages.report.col.city': '所屬城市',
  'pages.report.col.district': '所屬行政區',
  'pages.report.col.createTime': '建立時間',
  'pages.report.col.action': '操作',
  'pages.report.state.all': '全部',
  'pages.report.state.pendingFirst': '待一審',
  'pages.report.state.pendingSecond': '待二審',
  'pages.report.state.pendingThird': '待三審',
  'pages.report.state.pendingSeal': '待簽章',
  'pages.report.state.pendingModify': '待修改',
  'pages.report.state.done': '已完成',
  'pages.report.state.pendingArchive': '待歸檔',
  'pages.report.state.void': '已作廢',
  'pages.report.state.completedEnd': '已完結',
  'pages.report.state.pendingReview': '待審核',
  'pages.report.state.reviewed': '已審核',
  'pages.report.state.sealPending': '待簽章',
  'pages.report.state.sealed': '已簽章',
  'pages.report.process.pending': '待處理',
  'pages.report.process.done': '已處理',
  'pages.report.review.addDev': '新增報告功能開發中…',
  'pages.report.action.review': '審核',
  'pages.report.action.sign': '簽章',

  'pages.ledger.list.title': '台帳明細',
  'pages.ledger.list.fetchFail': '取得台帳列表失敗',
  'pages.ledger.list.directConnect': '直連',
  'pages.ledger.list.tokenRequired': '請輸入第三方平台的 token',
  'pages.ledger.list.syncFail': '同步失敗',
  'pages.ledger.list.directConnectDone': '直連已完成',
  'pages.ledger.list.directConnectAlready': '目前台帳已完成直連',
  'pages.ledger.list.initFail': '初始化失敗',
  'pages.ledger.list.initNoFileId': '初始化未傳回 fileId，無法儲存綁定',
  'pages.ledger.list.saveBindFail': '儲存與綁定失敗',
  'pages.ledger.list.flowFail': '轉交審核失敗',
  'pages.ledger.list.flowTimeout': '審核流程逾時，請稍後重試',
  'pages.ledger.list.editDirectFail': '編輯並直連失敗',
  'pages.ledger.list.searchConfigSaved': '搜尋項設定已儲存',
  'pages.ledger.list.ph.province': '請選擇省份',
  'pages.ledger.list.ph.city': '請選擇城市',
  'pages.ledger.list.ph.district': '請選擇區縣',
  'pages.ledger.list.ph.street': '請選擇街道',
  'pages.ledger.list.notFoundData': '暫無資料',
  'pages.ledger.list.notFoundSelectProvince': '請先選擇省份',
  'pages.ledger.list.notFoundSelectCity': '請先選擇城市',
  'pages.ledger.list.notFoundSelectDistrict': '請先選擇區縣',
  'pages.ledger.list.downloadTemplate': '正在下載範本…',
  'pages.ledger.list.templateFileName': '台帳明細匯入範本.xlsx',
  'pages.ledger.list.exporting': '正在匯出資料…',
  'pages.ledger.list.exportSuccess': '匯出成功',
  'pages.ledger.list.exportFail': '匯出台帳失敗',

  'pages.ledger.list.batchDirectConnect': '批量直連',
  'pages.ledger.list.autoDirectConnect': '自動直連',
  'pages.ledger.list.batchDirectConnectHint': '將對已選 {count} 條合格記錄發起批量直連',
  'pages.ledger.list.autoDirectConnectHint': '系統將自動篩選待直連記錄並發起任務，處理範圍由後端決定',
  'pages.ledger.list.directConnectTokenLabel': '使用者 token（必填）',
  'pages.ledger.list.batchDirectConnectSkipped': '已跳過 {count} 條不符合直連條件的記錄',
  'pages.ledger.list.batchDirectConnectNoEligible': '沒有可直連的記錄',
  'pages.ledger.list.batchDirectConnectStartFail': '批量直連任務啟動失敗',
  'pages.ledger.list.autoDirectConnectStartFail': '自動直連任務啟動失敗',
  'pages.ledger.list.autoDirectConnectNoRecords': '目前無待直連台帳',
  'pages.ledger.list.directConnectSkippedCount': '有 {count} 條記錄被跳過',
  'pages.ledger.list.directConnectJobTitle': '直連任務進度',
  'pages.ledger.list.directConnectTaskList': '直連任務',
  'pages.ledger.list.directConnectTaskListTitle': '直連任務列表',
  'pages.ledger.list.directConnectTaskListView': '查看進度',
  'pages.ledger.list.directConnectTaskListEmpty': '暫無直連任務',
  'pages.ledger.list.directConnectTaskType.BATCH': '批量直連',
  'pages.ledger.list.directConnectTaskType.AUTO': '自動直連',
  'pages.ledger.list.directConnectJobStatusLabel': '任務狀態',
  'pages.ledger.list.directConnectJobTotal': '總數',
  'pages.ledger.list.directConnectJobSuccess': '成功',
  'pages.ledger.list.directConnectJobFailed': '失敗',
  'pages.ledger.list.directConnectJobSkipped': '跳過',
  'pages.ledger.list.directConnectJobProcessing': '進行中',
  'pages.ledger.list.directConnectJobEmpty': '暫無明細',
  'pages.ledger.list.directConnectJobCompleted': '直連任務已全部成功',
  'pages.ledger.list.directConnectJobPartialFailed': '直連任務部分失敗',
  'pages.ledger.list.directConnectJobFailedMessage': '直連任務失敗',
  'pages.ledger.list.directConnectJobCancelled': '直連任務已終止',
  'pages.ledger.list.directConnectJobQueryFail': '查詢直連進度失敗',
  'pages.ledger.list.directConnectJobCloseTitle': '任務仍在進行中',
  'pages.ledger.list.directConnectJobCloseContent': '關閉後任務仍會在後台繼續，確定關閉進度視窗嗎？',
  'pages.ledger.list.directConnectCancelTask': '終止排隊',
  'pages.ledger.list.directConnectCancelSuccess': '任務已終止',
  'pages.ledger.list.directConnectCancelFailed': '任務已開始執行，無法終止',
  'pages.ledger.list.directConnectTokenDigest': 'Token 摘要',
  'pages.ledger.list.directConnectCol.ledgerRecordId': '台帳 ID',
  'pages.ledger.list.directConnectCol.taskId': '任務 ID',
  'pages.ledger.list.directConnectCol.taskType': '任務類型',
  'pages.ledger.list.directConnectCol.createTime': '創建時間',
  'pages.ledger.list.directConnectCol.status': '狀態',
  'pages.ledger.list.directConnectCol.failureType': '失敗分類',
  'pages.ledger.list.directConnectCol.failureReason': '失敗原因',
  'pages.ledger.list.directConnectTaskStatus.QUEUED': '排隊中',
  'pages.ledger.list.directConnectTaskStatus.RUNNING': '執行中',
  'pages.ledger.list.directConnectTaskStatus.CANCELLED': '已終止',
  'pages.ledger.list.directConnectTaskStatus.SUCCESS': '全部成功',
  'pages.ledger.list.directConnectTaskStatus.PARTIAL_FAILED': '部分失敗',
  'pages.ledger.list.directConnectTaskStatus.FAILED': '全部失敗',
  'pages.ledger.list.directConnectItemStatus.QUEUED': '排隊中',
  'pages.ledger.list.directConnectItemStatus.RUNNING': '執行中',
  'pages.ledger.list.directConnectItemStatus.SUCCESS': '成功',
  'pages.ledger.list.directConnectItemStatus.FAILED': '失敗',
  'pages.ledger.list.directConnectItemStatus.SKIPPED': '已跳過',
  'pages.ledger.list.directConnectFailureType.TOKEN_INVALID': 'token 失效',
  'pages.ledger.list.directConnectFailureType.DUPLICATE_ELECTRONIC_REPORT_CODE': '電子報告提取碼重複',
  'pages.ledger.list.directConnectFailureType.RAS_ERROR': '咕咕平台異常',
  'pages.ledger.list.directConnectFailureType.SYSTEM_ERROR': '系統異常',

  'pages.system.user.col.username': '使用者名稱',
  'pages.system.user.col.workNo': '工號',
  'pages.system.user.col.realName': '姓名',
  'pages.system.user.ph.realName': '請輸入姓名進行模糊查詢',
  'pages.system.user.col.email': '電子郵件',
  'pages.system.user.col.phone': '手機號碼',
  'pages.system.user.selectToDelete': '請選擇要刪除的使用者',
  'pages.system.user.batchDeleteFail': '批次刪除失敗',
  'pages.system.user.downloadTemplateLoading': '正在下載範本…',
  'pages.system.user.templateFileName': '使用者匯入範本.xlsx',
  'pages.system.user.templateDownloadSuccess': '範本下載成功',
  'pages.system.user.templateDownloadFail': '範本下載失敗，請稍後重試',
  'pages.system.user.uploadExcelOnly': '請上傳 Excel 檔案（.xlsx 或 .xls 格式）',
  'pages.system.user.fileTooLarge': '檔案大小不能超過 10MB',
  'pages.system.user.importDone': '使用者匯入完成',
  'pages.system.user.importFail': '匯入失敗',
  'pages.system.user.importFailRetry': '匯入失敗，請稍後重試',
  'pages.system.user.resetPwdTitle': '確認重設密碼',
  'pages.system.user.resetPwdContent': '確定要重設使用者「{name}」的密碼嗎？',
  'pages.system.user.resetPwdOk': '確認重設',
  'pages.system.user.resetPwdSuccess': '密碼重設成功',
  'pages.system.user.resetPwdFail': '密碼重設失敗',
  'pages.system.user.resetPwdFailRetry': '密碼重設失敗，請稍後重試',

  'pages.system.user.col.nickname': '暱稱',
  'pages.system.user.ph.nickname': '請輸入暱稱進行模糊查詢',
  'pages.system.user.col.gender': '性別',
  'pages.system.user.gender.male': '男',
  'pages.system.user.gender.female': '女',
  'pages.system.user.gender.unknown': '未知',
  'pages.system.user.col.roles': '角色',
  'pages.system.user.unassigned': '未分配',
  'pages.system.user.col.organization': '所屬機構',
  'pages.system.user.ph.organization': '請選擇機構',
  'pages.system.user.col.dept': '部門',
  'pages.system.user.ph.dept': '請選擇部門',
  'pages.system.user.col.status': '狀態',
  'pages.system.user.col.createTime': '建立時間',
  'pages.system.user.col.action': '操作',
  'pages.system.user.action.edit': '編輯',
  'pages.system.user.action.resetPwd': '重設密碼',
  'pages.system.user.action.delete': '刪除',
  'pages.system.user.exportTemplate': '匯出範本',
  'pages.system.user.import': '匯入',
  'pages.system.user.addUser': '新增使用者',
  'pages.system.user.deleteSuccess': '刪除成功',
  'pages.system.user.deleteFail': '刪除失敗',
  'pages.system.user.confirmToggleTitle': '確認{action}',
  'pages.system.user.confirmToggleContent': '確定要{action}該使用者嗎？',
  'pages.system.user.userNamed': '使用者「{name}」',
  'pages.system.user.userBracketNamed': '使用者【{name}】',
  'pages.system.user.batchUsers': '選中的 {count} 個使用者',
  'pages.system.user.deleteBatchSuccess': '成功刪除 {count} 個使用者',
  'pages.system.user.resetPwdContentInitial': '確定要重設該使用者的密碼為初始密碼嗎？',
  'pages.system.user.tableSelected': '已選擇 {count} 項',
  'pages.system.user.batchDeleteWithCount': '批次刪除 ({count})',
  'pages.system.user.cancelSelection': '取消選擇',
  'pages.system.user.importModalTitle': '匯入使用者',
  'pages.system.user.importProcessingFile': '正在處理檔案，請稍候…',
  'pages.system.user.importDragText': '點擊或拖曳檔案到此區域上傳',
  'pages.system.user.importFileHintLong':
    '支援單一 Excel 檔案上傳，格式：.xlsx、.xls，檔案大小不超過 10MB',
  'pages.system.user.importRunning': '正在匯入使用者資料…',
  'pages.system.user.importRunningHint': '請耐心等候，處理完成後將顯示匯入結果',
  'pages.system.user.importInstructionsTitle': '匯入說明：',
  'pages.system.user.importInstruction1': '請先下載範本檔案，依範本格式填寫使用者資訊',
  'pages.system.user.importInstruction2': '必填欄位：使用者名稱、姓名、電子郵件、手機號碼',
  'pages.system.user.importInstruction3': '性別：男/女/未知 或 1/2/3',
  'pages.system.user.importInstruction4': '角色與機構資訊請填寫正確名稱',
  'pages.system.user.importInstruction5': '匯入過程如有錯誤，系統可能產生失敗檔案供下載查看',
  'pages.system.user.deptUnnamed': '未命名部門',
};
